import { renderTagItem } from './tagUtils';

const tag = value => renderTagItem(value);

export default tag;
